export default `query CheckIsCustomer($exampleEmail: String!) {
  isCustomer(email: $exampleEmail)
}`;
